import React, { useCallback, useEffect, useMemo, useState } from 'react'
import classnames from 'classnames'
import { downAndUpArrow, arrowDownWhite } from '../../constants'
import styles from './index.module.less'
import { SelectItemProps } from '../../types'

interface LayerSelectProps<T> {
  options: SelectItemProps<T>[]
  onChange: (key: T) => void
  value: T
}

function Content<T>(props: LayerSelectProps<T> & { onCancel: () => void }) {
  const { options, onChange, value } = props
  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      className={styles['select-content']}
    >
      <div className={styles['stage']}>
        {options.map((ele) => (
          <div
            key={`${ele.id}`}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onChange(ele.id)
            }}
            className={classnames({
              [styles['item']]: true,
              [styles['item_active']]: value === ele.id,
            })}
          >
            {ele.timeRange}
          </div>
        ))}
      </div>
    </div>
  )
}

/**
 * todo: 添加动效
 * @param props
 */
function LayerSelect<T>(props: LayerSelectProps<T>) {
  const { options, value, onChange } = props

  const valueItem = useMemo(() => options.find((it) => it.id === value), [options, value])
  const [visible, setVisible] = useState(false)
  const onOk = useCallback(
    (val: T) => {
      setTimeout(() => {
        setVisible(false)
      }, 100)
      onChange(val)
    },
    [onChange]
  )

  const onCancel = useCallback(() => {
    setVisible(false)
  }, [])

  const isLessOneOption = options.length <= 1

  const onValueClick = useCallback(() => {
    if (isLessOneOption) {
      return
    }
    setVisible((pre) => !pre)
  }, [isLessOneOption])

  useEffect(() => {
    if (!visible) {
      return
    }
    function cb() {
      setVisible(false)
    }
    document.addEventListener('click', cb)
    return () => {
      document.removeEventListener('click', cb)
    }
  }, [visible])

  return (
    <div className={styles['layer-select']}>
      <div onClick={onValueClick} className={styles['select-line']}>
        {valueItem ? valueItem.timeRange : null}
        {isLessOneOption ? null : (
          <img
            className={classnames({
              [styles['select-icon']]: true,
              [styles['select-icon_reverse']]: visible,
            })}
            src={arrowDownWhite}
            alt=""
          />
        )}
      </div>
      {visible && <Content {...props} onChange={onOk} onCancel={onCancel} />}
    </div>
  )
}

export default LayerSelect
